export function BundlesPreview(): string {
	return `/v1/payment/bundles`;
}

export function Currencies(organizationID: number): string {
	return `/v1/organizations/${organizationID}/payment/currencies`;
}

export function InitiateManageDisputes(organizationID: number, groupPaymentConfigID: number): string {
	return `/v1/organizations/${organizationID}/group-payment-config/${groupPaymentConfigID}/manage-disputes`;
}

export function Preview(): string {
	return `/v1/payment/cart`;
}

